import { DestroyRef, Directive, HostListener, inject, input, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounceTime, filter, Subject } from 'rxjs';

export interface ViewportSentinel {
  isInViewPort(): boolean;
}

@Directive({
  selector: '[appInfiniteScroll]',
})
export class InfiniteScrollDirective {
  private destroyRef = inject(DestroyRef);
  private sentinels = new Set<ViewportSentinel>();
  private scroll$ = new Subject<void>();

  debounceTime = input(200);
  scrollWindow = output<void>();
  nearEnd = output<void>();

  constructor() {
    this.scroll$
      .pipe(
        debounceTime(this.debounceTime()),
        filter(() => [...this.sentinels].some((s) => s.isInViewPort())),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.nearEnd.emit();
      });
  }

  register(sentinel: ViewportSentinel) {
    this.sentinels.add(sentinel);
  }

  unregister(sentinel: ViewportSentinel) {
    this.sentinels.delete(sentinel);
  }

  @HostListener('window:scroll')
  protected onScroll() {
    this.scroll$.next();
    this.scrollWindow.emit();
  }
}
